import { AgreementsRootState } from 'store/types';

export const getAgreedToTerms = (store: AgreementsRootState) =>
  store.agreements.hasAgreed;
